import api from './api';

export interface AppNotification {
  _id: string;
  recipient: string;
  recipientRole: string;
  company: string;
        type: 'TICKET_CREATED' | 'TICKET_APPROVED' | 'TICKET_REJECTED' | 'TICKET_ASSIGNED' | 
        'TICKET_UPDATED' | 'TICKET_RESOLVED' | 'USER_CREATED' | 'USER_UPDATED' | 
        'MESSAGE_RECEIVED' | 'APPROVAL_NEEDED' | 'PROJECT_MENTION' | 'PROJECT_TASK_UPDATED' |
        'DEAL_CREATED' | 'DEAL_UPDATED' | 'DEAL_DELETED' |
        'INVOICE_CREATED' | 'INVOICE_PAID';
  title: string;
  message: string;
  relatedTicket?: any;
  relatedUser?: any;
  relatedProject?: any;
  relatedTask?: any;
  relatedDeal?: any;
  relatedInvoice?: any;
  isRead: boolean;
  createdAt: string;
}

export const notificationService = {
  async getNotifications(unreadOnly = false): Promise<{ data: AppNotification[]; unreadCount: number }> {
    const response = await api.get('/notifications', {
      params: { unreadOnly }
    });
    return response.data;
  },

  async markAsRead(id: string): Promise<AppNotification> {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data.data;
  },

  async markAllAsRead(): Promise<void> {
    await api.patch('/notifications/mark-all-read');
  },

  async deleteNotification(id: string): Promise<void> {
    await api.delete(`/notifications/${id}`);
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.count;
  }
};

